import { FC, ReactNode } from 'react';
import { Popover } from 'antd';
import { FlashSaleIcon, FlashSaleIconES, FlashSaleIconFR, FlashSaleIconIT } from '@/components/EcocreditsMonthlyMadness/Svg';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

const FlashSaleHeader: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('appreciationday');
    // const secKillisBegin = false;
    // const secKillProduct = [] as any;
    const { secKillisBegin, secKillProduct } = useMonthlyStore();

    const Icon: Record<string, ReactNode> = {
        eu: <FlashSaleIcon />,
        it: <FlashSaleIconIT />,
        es: <FlashSaleIconES />,
        fr: <FlashSaleIconFR />,
    };

    const content = () => (
        <>
            <p>{t('exclusive.step1')}</p>
            <p>{t('exclusive.step2')}</p>
        </>
    );

    if (!secKillProduct || secKillProduct.length === 0) return <></>;

    return (
        <div className={`${styled.FlashSaleHeader}`}>
            {/* pc和移动端层级不同 */}
            <div className="pc">
                <h5 className="title">
                    {Icon[locale] || Icon.eu}
                    <span>{!secKillisBegin ? t('exclusive.title') : t('exclusive.title1')}</span>
                </h5>
                <p className="subtitle">
                    {!secKillisBegin ? t('exclusive.subtitle') : t('exclusive.subtitle1')}
                    {/* <Popover overlayClassName={styled.pop} content={content} title={null} placement="topRight" trigger="click">
                        <span>{t('exclusive.steps')}</span>
                    </Popover> */}
                </p>
                <p className="subtitle">{t('exclusive.email_title')}</p>
            </div>
            {/* pc和移动端层级不同 */}
            <div className="mobile">
                {Icon[locale] || Icon.eu}
                <div className="text">
                    <h5 className="title">{!secKillisBegin ? t('exclusive.title') : t('exclusive.title1')}</h5>
                    <p className="subtitle">
                        {!secKillisBegin ? t('exclusive.subtitle') : t('exclusive.subtitle1')}
                        {/* <Popover overlayClassName={styled.pop} content={content} title={null} placement="topRight" trigger="click">
                            <span>{t('exclusive.steps')}</span>
                        </Popover> */}
                    </p>
                    <p className="subtitle">{t('exclusive.email_title')}</p>
                </div>
            </div>
        </div>
    );
};

export default FlashSaleHeader;
